import React from 'react'
import { getDirectionUrl, openExtUrl } from '../../utils/commanFunctions'

const HotelPageCard = ({card, onCardClick}) => {
    

    
  return (
    <div
    onClick={(e)=>{
          e.stopPropagation()
           onCardClick()
         }}

     className='hotel-page-card rounded-[12px] bg-[#FFFFFF] h-[88px] border-[#0000000F] border-[1px] flex items-center p-4 gap-[12px] cursor-pointer'>

        <div className='h-[40px] w-[40px] min-h-[40px] min-w-[40px] bg-[#EAEAEA] rounded-full flex justify-center items-center'>
            {card.icon}
        </div>
        <div>
            <div className='text-[#1A1A1A] text-[14px]'>{card.title}</div>
            <div className='text-[#4D4D4D] text-[12px] leading-[18px]'>{card.subTitle}</div>
        </div>
    </div>
  )
}

export default HotelPageCard